/**
 * Get devices from the browser API. This will list only the devices that
 * may be recognized by the browser
 * @param deviceKind 
 * @returns 
 */
export async function getDefaultDevice(deviceKind: MediaDeviceKind): Promise<MediaDeviceInfo | undefined>
{
    try
    {
        //get list devices
        const devices = await navigator.mediaDevices.enumerateDevices()
        const videoDevices: MediaDeviceInfo[] = []
        //iterate list of devices and add if is equals to devicekind param
        devices.forEach(device => {
            if(device.kind === deviceKind)
                videoDevices.push(device)
        })
        //send error if arrays of devices is zero
        if(videoDevices.length === 0)
            throw new Error("Could not get devices")
        //return first devices of array    
        return videoDevices[0]
    }
    //in case of error print info and return undefined
    catch(error)
    {
        console.error("getDefaultDevice", error)
        return undefined
    }
}

/**
 * Retrieves media devices connected to the device (computer, phone, etc) 
 * that are compatible with the browser
 * @param typeSelected Media kind
 * @returns 
 */
export async function getMediaDevices(typeSelected: "audio" | "video"): Promise<MediaDeviceInfo[]>
{
    const tempDevices: MediaDeviceInfo[] = []

    // Get devices from browser API
    const devices = await navigator.mediaDevices.enumerateDevices()

    // Filter devices by media kind
    const kind = typeSelected === "audio" ? "audioinput" : "videoinput"
    devices.forEach(device => {
        if(device.kind === kind)
            tempDevices.push(device)
    })
    
    return tempDevices
}
